import { useMemo } from 'react'
import { Image, Link } from '@chakra-ui/react'
import { buildAssetUrlString, getDevice } from '@!/Util'
import monthlyCoursePromoBanner from '@images/monthly_course_promo_banner.webp'

export const MonthlyCoursePromoBanner = () => {
  const device = useMemo(() => getDevice(), [])
  const width = device === 'sp' ? '100%' : '70%'

  return (
    <Link as="a" href="/user/payment#/monthly_course" display="inline-block" w={width}>
      <Image src={buildAssetUrlString(monthlyCoursePromoBanner)} alt="月額コースが圧倒的にオトク!" w="100%" h="auto" />
    </Link>
  )
}
